import React from 'react'
import {connect} from 'react-redux'
import {change as changeFieldValue, Field, reduxForm} from 'redux-form';
import Select from 'react-select';
import Titulo from '../comum/Titulo';
import buscarPrecos from '../../actions/preco/buscarPrecos';
import pesquisarPrecos from '../../actions/preco/pesquisarPorPrecos';
import excluirPrecos from '../../actions/preco/excluirPreco';
import {alterouPagina} from '../../util/filtros';
import {
    getAdminEmpresa,
    getGestorEmpresa,
    getOperadorEmpresa,
    getGestorOperacoes,
    getPerfisVendedores,
    PERFIL_ADMIN
} from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import Preco from './Preco'
import ModalCadastrarPreco from './ModalCadastrarPreco';
import {alterouEmpresa} from '../../actions/empresa/alterarEmpresaSelecionada';
import determinaPaginaAtual from '../../actions/preco/determinarPaginaAtualPreco'
import buscarTrechos from '../../actions/trecho/buscarTrechos'
import limparPrecos from '../../actions/preco/limparPrecos'
import CabecalhoRodapeTabela from '../comum/CabecalhoRodapeTabela';
import PaginacaoPreco from './PaginacaoPreco';
import BotoesPaginacaoPreco from './BotoesPaginacaoPreco';
import CampoSelecionarEmpresa from '../layout/CampoSelecionarEmpresa';
import buscarTiposPreco from '../../actions/preco/buscarTiposPreco';
import SelecaoCidadeAutocomplete from '../layout/SelecaoCidadeAutocomplete';
import selecionarDestino from '../../actions/destino/selecionarDestino';
import selecionarOrigem from '../../actions/origem/selecionarOrigem';
import {estados} from '../../util/constantsUtil';
import {showSuccessMsg} from '../../util/messagesUtil';
import ModalImportarPreco from './ModalImportarPreco';
import {importarPrecos} from '../../actions/preco/cadastrarPreco'
import ModalHistoricoPrecos from './ModalHistoricoPrecos';
import $ from 'jquery';

export const CabecalhoTabela = () => (
    <div className="vx-list-header vx-list-header--preco">
        <div className="vx-list-header-cell">Cidade origem</div>
        <div className="vx-list-header-cell">Cidade destino</div>
        <div className="vx-list-header-cell">Tipo veículo</div>
        <div className="vx-list-header-cell">Valor</div>
        <div className="vx-list-header-cell">Ações</div>
    </div>
);

const ModalConfirmacaoExclusaoPreco = ({excluir, preco}) => (
    <div className="modal fade" id="modalConfirmacaoExclusaoPreco" tabIndex="-1" role="dialog"
         aria-labelledby="modalConfirmacaoExclusaoPreco" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-sm" role="document">
            <div className="modal-content" style={{ borderRadius: 12, overflow: 'hidden', border: 'none' }}>
                <div className="vx-modal-header">
                    <div className="vx-modal-title">
                        <span className="material-icons">delete</span>
                        Excluir Valor
                    </div>
                </div>
                <div className="vx-modal-body" style={{ background: '#fff', textAlign: 'center' }}>
                    <p style={{ margin: 0, fontSize: 14, color: '#444' }}>
                        Deseja excluir <strong>{preco ? preco.name : ''}</strong>?
                    </p>
                </div>
                <div className="vx-modal-footer">
                    <button type="button" className="vx-modal-btn-fechar" data-dismiss="modal">Cancelar</button>
                    <button type="button" className="vx-modal-btn-confirmar" data-dismiss="modal"
                            onClick={() => excluir()}>
                        <span className="material-icons" style={{ fontSize: 15 }}>delete</span>
                        Excluir
                    </button>
                </div>
            </div>
        </div>
    </div>
);

export class PainelGerenciarPreco extends React.Component {
    constructor(props) {
        super(props);
        this.selecionarPreco = this.selecionarPreco.bind(this);
        this.selecionarTrecho = this.selecionarTrecho.bind(this);
        this.montarParametroPreco = this.montarParametroPreco.bind(this);
        this.limparCampos = this.limparCampos.bind(this);
        this.excluir = this.excluir.bind(this);
        this.abrirModalNovoValor = this.abrirModalNovoValor.bind(this);
        this.state = {
            precoSelecionado: null,
            textoFiltro: null,
            parametros: {},
            tipoPrecoObjSelecionado: null,
            habilitadoPrecoVolta: true
        };
    }

    UNSAFE_componentWillMount() {
        this.props.determinaPaginaAtual(1)
    }

    componentDidMount() {
        this.props.limparPrecos();
        this.props.buscarTiposPreco();
        if (this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
            this.props.buscarPrecos(this.props.empresaSelecionada.id, [], 0, 10);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (alterouEmpresa(this.props, prevProps)
            || alterouPagina(this.props, prevProps)
            || this.state.parametros !== prevState.parametros) {
            this.buscarPrecos();
        }
    }

    limparEmpresaSelecionada() {
        this.setState({precoSelecionado: null});
    }

    buscarPrecos() {
        this.props.buscarPrecos(this.props.empresaSelecionada.id, this.state.parametros, this.props.paginaAtual, this.props.registrosPorPagina);
    }

    // eslint-disable-next-line class-methods-use-this
    montarParametroPreco(values) {
        return {
            id: values.idPreco,
            cidadeOrigemId: values.cidadeOrigem.value,
            cidadeDestinoId: values.cidadeDestino.value,
            empresaId: this.props.empresaSelecionada.id,
            tipoPreco: values.tipo.value,
            valor: values.valor ? values.valor.replace('R$', '') : null,
            valorAntt: values.valorAntt ? values.valorAntt.replace('R$', '') : null,
            tarifaSeguro: values.tarifaSeguro ? values.tarifaSeguro.replace('R$', '') : null,
            habilitadoPrecoVolta: values.habilitadoPrecoVolta
        };
    }

    selecionarPreco(preco) {
        this.setState({precoSelecionado: preco});
    }

    selecionarTrecho(trecho) {
        this.setState({trechoSelecionado: trecho});
    }

    excluir() {
        this.props.excluirPrecos(this.state.precoSelecionado.id, this.props.empresaSelecionada.id)
            .then(() => {
                showSuccessMsg('Valor excluído com Sucesso!');
                this.buscarPrecos();
                this.limparEmpresaSelecionada();
            })
    }

    limparCampos() {
        this.props.changeFieldValue('formularioCadastroPreco', 'idPreco', '');
        this.props.changeFieldValue('formularioCadastroPreco', 'origem', '');
        this.props.changeFieldValue('formularioCadastroPreco', 'destino', '');
        this.props.changeFieldValue('formularioCadastroPreco', 'trechos', '');
        this.props.limparPrecos();
    }

    exibirComboTipoVeiculo(event) {
        if (!this.props.tiposPreco) {
            return ''
        }
        return (
            <React.Fragment>
                <Select
                    {...event.input}
                    noOptionsMessage={() => ('Nenhuma opção encontrada')}
                    styles={{
                        control: (base, {isDisabled}) => ({
                            ...base, height: 44.25, minHeight: 32, fontSize: 16,
                            width: '100%', borderColor: 'hsl(0,0%,80%)',
                            backgroundColor: isDisabled ? '#e4e7ea' : '#FFF',
                            color: '#5c6873', cursor: 'pointer'
                        })
                    }}
                    placeholder='Tipo veículo'
                    value={this.state.parametros.tipoPreco ? {
                        label: this.state.tipoPrecoObjSelecionado.label,
                        value: this.state.tipoPrecoObjSelecionado.value
                    } : ''}
                    isDisabled={this.state.parametros.tipoPreco}
                    options={this.props.tiposPreco.map(elemento => ({
                        label: elemento.descricaoTipoPreco,
                        value: elemento.tipoPreco
                    }))}
                    onChange={elemento => this.selecionarTipoPreco(elemento)}
                />
            </React.Fragment>
        )
    }

    selecionarDestino(value) {
        this.setState({ parametros: { ...this.state.parametros, destino: value } })
    }

    selecionarOrigem(value) {
        this.setState({ parametros: { ...this.state.parametros, origem: value } })
    }

    selecionarTipoPreco(tipoPreco) {
        this.setState({ tipoPrecoObjSelecionado: tipoPreco });
        this.setState({ parametros: { ...this.state.parametros, tipoPreco: tipoPreco ? tipoPreco.value : tipoPreco } })
    }

    exibirLimparTipoPreco() {
        if (this.state.parametros.tipoPreco) {
            return (
                <button type="button" style={{ border: 'none', background: 'none', color: '#e53935', cursor: 'pointer', padding: '0 4px' }}
                    onClick={() => this.selecionarTipoPreco('')}>
                    <span className="material-icons" style={{ fontSize: 18 }}>close</span>
                </button>
            )
        }
    }

    exibirCamposBusca() {
        return (
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, alignItems: 'center', margin: '12px 0' }}>
                <div style={{ minWidth: 200 }}>
                    <Field name='tipoVeiculo' component={this.exibirComboTipoVeiculo.bind(this)} />
                </div>
                {this.exibirLimparTipoPreco()}
                <div style={{ minWidth: 220 }}>
                    <SelecaoCidadeAutocomplete
                        ehVenda={false}
                        exibeLimpar={this.state.parametros.origem} limpar={this.selecionarOrigem.bind(this)}
                        disabled={this.state.parametros.origem} readOnly={true} nome='pesquisaOrigem'
                        placeholder='Cidade origem' selecionarCidade={this.selecionarOrigem.bind(this)} />
                </div>
                <div style={{ minWidth: 220 }}>
                    <SelecaoCidadeAutocomplete
                        ehVenda={false}
                        exibeLimpar={this.state.parametros.destino} limpar={this.selecionarDestino.bind(this)}
                        disabled={this.state.parametros.destino} nome='pesquisaDestino' placeholder='Cidade destino'
                        selecionarCidade={this.selecionarDestino.bind(this)} />
                </div>
            </div>
        )
    }

    abrirModalNovoValor() {
        this.setState({ habilitadoPrecoVolta: true }, () => {
            $('#modalCadastrarPreco').modal('show');
        });
    }

    exibirTabelaPrecos() {
        if (this.props.precos && this.props.precos.length) {
            return (
                <div className="vx-list-container">
                    <CabecalhoRodapeTabela OpcoesPaginacao={PaginacaoPreco}
                                           BotoesPaginacao={BotoesPaginacaoPreco}
                                           precos={this.props.precos}
                                           empresaSelecionada={this.props.empresaSelecionada}>
                        <CabecalhoTabela />
                        {this.exibirPrecos()}
                    </CabecalhoRodapeTabela>
                </div>
            )
        }
        return (
            <div className="vx-list-container">
                <div className="vx-empty-state">
                    <span className="material-icons">search</span>
                    <p>Nenhum valor cadastrado para a empresa selecionada</p>
                </div>
            </div>
        );
    }

    exibirPrecos() {
        if (this.props.precos) {
            return this.props.precos.map((preco, index) => (
                <Preco idEmpresa={this.props.empresaSelecionada.id}
                       key={index} preco={preco}
                       selecionarPreco={this.selecionarPreco}
                       indice={index} />
            ))
        }
    }

    render() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id),
                getGestorOperacoes(this.props.empresaSelecionada.id),
                ...getPerfisVendedores(this.props.empresaSelecionada.id)]}
                empresaSelecionada={this.props.empresaSelecionada}>
                <div>
                    <div className="row internas">
                        <Titulo texto="Gerenciar Valores" urlRetorno="/menu-preco" />
                        <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                            <div className="col-12 conteudo-internas conteudo-painel area-btn-filtro-painel">
                                <ul className="nav navbar-nav ml-auto opcoes-menu menu-desktop">
                                    <li className="nav-item dropdown nome-empresa">
                                        <div className="col-md-6">
                                            <CampoSelecionarEmpresa />
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </Autorizacao>
                        <div className="col-12 conteudo-internas conteudo-painel area-btn-filtro-painel">
                            {this.exibirCamposBusca()}
                            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                getAdminEmpresa(this.props.empresaSelecionada.id),
                                getGestorEmpresa(this.props.empresaSelecionada.id),
                                getGestorOperacoes(this.props.empresaSelecionada.id),
                                getOperadorEmpresa(this.props.empresaSelecionada.id)]}>
                                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginBottom: 12 }}>
                                    <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                                        <button data-toggle="modal" data-target="#modalImportarPrecos"
                                            className="vx-toolbar-btn vx-toolbar-btn--secondary">
                                            <span className="material-icons" style={{ fontSize: 16 }}>cloud_upload</span>
                                            Importar preços
                                        </button>
                                    </Autorizacao>
                                    <button onClick={this.abrirModalNovoValor} className="vx-toolbar-btn">
                                        <span className="material-icons" style={{ fontSize: 16 }}>add</span>
                                        Novo Valor
                                    </button>
                                </div>
                            </Autorizacao>
                            {this.exibirTabelaPrecos()}
                        </div>
                    </div>
                    <ModalImportarPreco
                        empresas={this.props.empresas}
                        buscarPrecos={this.props.buscarPrecos}
                        codigoEmpresaSelecionada={this.props.empresaSelecionada.id}
                        importarPrecos={this.props.importarPrecos}
                        tiposPreco={this.props.tiposPreco} />
                    <ModalCadastrarPreco
                        estados={estados}
                        parametros={this.state.parametros}
                        montarParametroPreco={this.montarParametroPreco}
                        habilitadoPrecoVolta={this.state.habilitadoPrecoVolta} />
                    <ModalConfirmacaoExclusaoPreco excluir={this.excluir} preco={this.state.precoSelecionado} />
                    <ModalHistoricoPrecos />
                </div>
            </Autorizacao>
        )
    }
}

export const mapStateToProps = state => ({
    precos: state.precoPaginacao.precos,
    empresas: state.empresas,
    changeFieldValue,
    empresaSelecionada: state.empresaSelecionada,
    paginaAtual: state.paginaAtualPreco,
    registrosPorPagina: state.registrosPorPaginaPreco,
    tiposPreco: state.tiposPreco,
    tipoVeiculoSelecionado: state.tipoVeiculoSelecionado,
});

export default connect(mapStateToProps, {
    buscarPrecos,
    excluirPrecos,
    determinaPaginaAtual,
    buscarTrechos,
    pesquisarPrecos,
    limparPrecos,
    selecionarDestino,
    selecionarOrigem,
    buscarTiposPreco,
    importarPrecos
})(reduxForm({
    form: 'formularioCadastroPreco'
})(PainelGerenciarPreco))
